export const constants = {
  user: 'USER',
  token: 'access_token',
  language: 'LNG',
  videosCompareList: 'videos_compare_list',
  hashtagsCompareList: 'hashtags_compare_list',
  topicsCompareList: 'topics_compare_list',
  sideMenuState: 'side-menu-state',
  APP_SETTINGS: 'APP_SETTINGS',
  TIME_ZONE: 'TIME_ZONE',
  LANDING_PAGE: 'LANDING_PAGE',
  TIME_FORMAT: 'TIME_FORMAT',
  TIME_24: 'TIME_24',
  TRENDING_DURATION: 'TRENDING_DURATION',
  AUTHORIZED_MODULES: 'AUTHORIZED_MODULES',
  CURRENT_ROUTE: 'CURRENT_ROUTE',
  SESSION_STORAGE_DATA: 'SESSION_STORAGE_DATA',
  IS_STORY: 'IS_STORY',
  darkMode: 'DARK_MODE',
};

export const setAccessTokenInLocalStorage = (value: string): void => {
  const sessionData = getFromSessionStorage(constants.SESSION_STORAGE_DATA);
  if (sessionData) {
    setInSessionStorage(constants.SESSION_STORAGE_DATA, {
      ...sessionData,
      access_token: value,
    });
    return;
  }

  setInLocalStorage('access_token', value);
};

export const setRefreshTokenInLocalStorage = (value: string): void => {
  const sessionData = getFromSessionStorage(constants.SESSION_STORAGE_DATA);
  if (sessionData) {
    setInSessionStorage(constants.SESSION_STORAGE_DATA, {
      ...sessionData,
      refresh_token: value,
    });
    return;
  }

  setInLocalStorage('refresh_token', value);
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const setUserInLocalStorage = (value: any): void => {
  const sessionData = getFromSessionStorage(constants.SESSION_STORAGE_DATA);
  if (sessionData) {
    setInSessionStorage(constants.SESSION_STORAGE_DATA, value);
  } else {
    setInLocalStorage(constants.user, value);
  }
};

export const setInLocalStorage = <T = any>(key: string, value?: T): void => {
  if (value) {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.removeItem(key);
  }
};
export const setInSessionStorage = <T = any>(key: string, value?: T): void => {
  if (value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  } else {
    sessionStorage.removeItem(key);
  }
};
export const getAccessTokenFromLocalStorage = (): string | null => {
  const sessionData = getFromSessionStorage(constants.SESSION_STORAGE_DATA);
  if (sessionData) {
    return sessionData?.access_token;
  }
  return getFromLocalStorage('access_token');
};

export const getRefreshTokenFromLocalStorage = (): string | null => {
  const sessionData = getFromSessionStorage(constants.SESSION_STORAGE_DATA);
  if (sessionData) {
    return sessionData?.refresh_token;
  }
  return getFromLocalStorage('refresh_token');
};

export const getFromLocalStorage = (key: string): any | null => {
  if (
    key === constants.user &&
    getFromSessionStorage(constants.SESSION_STORAGE_DATA)
  ) {
    return getFromSessionStorage(constants.SESSION_STORAGE_DATA);
  }

  const value = localStorage.getItem(key);

  if (value) {
    try {
      return JSON.parse(value);
    } catch (err) {
      return value;
    }
  }

  return null;
};

export const getFromSessionStorage = (key: string): any | null => {
  const value = sessionStorage.getItem(key);

  if (value) {
    try {
      return JSON.parse(value);
    } catch (err) {
      return value;
    }
  }

  return null;
};
